import { createFeatureSelector, createSelector } from '@ngrx/store';
import moment from 'moment';
import { Event } from '../../models/event.model';
import { EventState, eventAdapter } from '../reducers/event.reducer';

export const getEventState = createFeatureSelector<EventState>('events');
export const getIds = (state: EventState) => state.ids;
export const eventStatsLoading = (state: EventState) => state.eventStatsLoading;
export const loading = (state: EventState) => state.loading;
export const inProgress = (state: EventState) => state.inProgress;

export const {
  selectIds: getEventIds,
  selectEntities: getEventEntities,
  selectAll: getAllEvents,
  selectTotal: getTotalEvents,
} = eventAdapter.getSelectors(getEventState);

export const getEventsByGroupId = (groupId: string) =>
  createSelector(getAllEvents, (allItems) => {
    // if (allItems) {
    return allItems
      .filter((item) => {
        return item.groupId === groupId;
      })
      .sort(sortDescendingByStartDate);
  });

export const getDateSortedEvents = (groupId: string, month: moment.Moment) =>
  createSelector(getAllEvents, (allItems) => {
    var events: any = {};
    const groupEvents = allItems
      .filter((item) => {
        return (
          item.groupId === groupId &&
          moment(item.startDateTime.toDate()).format('MM-YYYY') ===
            month.format('MM-YYYY')
        );
      })
      .sort(sortAscendingByStartDate);

    groupEvents.forEach((event) => {
      const startDate = moment(event.startDateTime?.toDate()).format(
        'DD-MM-YYYY'
      );
      if (events[startDate] == null) {
        events[startDate] = [];
      }
      events[startDate].push(event);
    });
    return events;
  });

function sortDescendingByStartDate(a: Event, b: Event): number {
  return a.startDateTime.toDate() > b.startDateTime.toDate()
    ? -1
    : a.modified.toDate() < b.modified.toDate()
    ? 1
    : 0;
}

function sortAscendingByStartDate(a: Event, b: Event): number {
  return a.startDateTime.toDate() < b.startDateTime.toDate()
    ? -1
    : a.modified.toDate() < b.modified.toDate()
    ? 1
    : 0;
}

export const getEventById = (eventId: string) =>
  createSelector(getAllEvents, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === eventId;
      });
    } else {
      return null;
    }
  });
